import React, { useState, useEffect, useReducer, useRef } from "react";
import ScrollView from "devextreme-react/scroll-view";
import "../../styles/sps.css";
import Button from "devextreme-react/button";
import { FileUploader, TextArea, TextBox } from "devextreme-react";
import DataGrid, {
  Lookup,
  RequiredRule,
  SearchPanel,
} from "devextreme-react/data-grid";
import WhiteBoard from "../common/WhiteBoard/WhiteBoard";
import { Column, Editing, Paging } from "devextreme-react/data-grid";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import * as utils from "../../common/utils";
import sa3 from "../../reducers/sa3";
import * as actions from "../../actions/sa3";
import { confirm } from "devextreme/ui/dialog";
import { onDownloadFile } from "../../common/utils";
import notify from "devextreme/ui/notify";
import { isEmpty } from "lodash";
import { alert } from "devextreme/ui/dialog";
import { postUserLog } from "../../actions/common";
import { postLogForFilter } from "./utils";
import config from "../../common/config";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";
const initialStates = {
  approvers: [],
  peopleData: [],
  reasonCodes: [],
  peopleList: [],
};
const initialState = {
  startDate: new Date(),
};

const InitialState = (props) => {
  const [WBRc, setWBRc] = useState(false);
  const [enableadd, setenableadd] = useState(true);
  const [GridData, setGridData] = useState([]);
  const [Comments, setComments] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [image, setImage] = useState(null);
  const [state, dispatch] = useReducer(sa3, initialState);
  let { targetStateA3Data, attachmentsA3 } = state;
  const [isDisabled, setIsDisabled] = useState(true);

  const dataGridRef = useRef(null);
  let wbIs, wbRc;
  const wBRc = (k) => {
    wbRc = k;
  };
  const wBIs = (k) => {
    wbIs = k;
  };
  useEffect(() => {
    actions.fetchTargetDataA3(dispatch, props.a3ID, "2");
    actions.GetAttachmentsDataA3(dispatch, props.a3ID, "KPIInitialState");
    AsyncCallHandler(
      NEXUS_CONST.FETCH_A3_DATA + props.a3ID,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setIsDisabled(res?.data?.status === "Complete");
      }
    });
  }, []);

  //Whiteboard set call and setting other data for the page
  useEffect(() => {
    setGridData(targetStateA3Data?.targetDataGrid);
    setComments(targetStateA3Data?.comments.comments);

    utils.set(
      "wbData_isa3",
      targetStateA3Data?.whiteBoard
        ? JSON.parse(targetStateA3Data.whiteBoard)
        : { objects: [] }
    );
  }, [targetStateA3Data]);

  const typeValue = ["Driver", "Watch"];

  const initialstateConfig = {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,

    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    sorting: {
      mode: "row",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    // searchPanel: {
    //   visible: true,
    // },
    paging: {
      pageSize: 10,
    },
    pager: {
      showPageSizeSelector: true,
      allowedPageSizes: [5, 10, 20, 50],
      showInfo: true,
    },

    export: {
      enabled: true,
      fileName: "Initial_State",
    },
    editing: {
      mode: "cell",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
  };
  const onRowUpdated = () => {
    setenableadd(true);
  };
  const onRowInserted = () => {
    setenableadd(true);
  };
  const handlers = {
    onRowUpdated: onRowUpdated,
    onRowInserted: onRowInserted,
  };

  //files attachments handling
  const onFileSelect = (e) => {
    setSelectedFiles(e.value);

    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
  };

  const deleteFile = (id, attachmentName) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );
    confirm_it.then((res) => {
      actions.deleteAttachmentA3(
        dispatch,
        id,
        props.a3ID,
        "KPIInitialState",
        attachmentName,
        props.TierId,
        props.activeTab
      );
      // AsyncCallHandler(
      //   NEXUS_CONST.DELETE_ATTACHMENT_A3 + id,
      //   NEXUS_CONST.POST
      // ).then((res) => {
      //   actions.GetAttachmentsDataA3(dispatch, 3, "KPIInitialState");
      // });
    });
  };
  function handleGridOptionChanged(e) {
    postLogForFilter(
      dataGridRef,
      e,
      props.SiteId,
      props.TierId,
      "Solution Approach",
      5,
      props.a3ID,
      props.activeTab
    );
  }
  const handlTextBox = (e) => {
    setComments(e.value);
  };

  //save data
  const saveInitialstate = () => {
    dataGridRef.current?.instance?.saveEditData();
    let initialStateWB = utils.get("wbData_isa3")
      ? JSON.stringify(utils.get("wbData_isa3"))
      : { objects: [] };

    const validateUploadFiles = checkUploadFilesValid(
      selectedFiles,
      ALLOWED_MIME_TYPES
    );

    if (validateUploadFiles.length) {
      const alertMsg = validateUploadFiles.map(
        (file) => `${file.name} - ${file.reason}`
      );
      alert(alertMsg.join("<br/>"), "Alert");
      return false;
    }

    let newTableData = GridData;
    //validations (atleast one row in data grid, adding comments)

    if (newTableData.length == 0) {
      alert("Please enter atleast one KPI into table", "Alert");
    } else if (
      Comments == null ||
      Comments == undefined ||
      Comments.length == 0
    ) {
      alert("Please enter Qualitative Comments", "Alert");
    } else {
      newTableData.forEach((obj, index) => {
        if ("__KEY__" in obj) {
          newTableData[index] = {
            id: 0,
            a3id: props.a3ID,
            typeId: obj.type === "Driver" ? 1 : 2,
            type: obj.type,
            kpi: obj.kpi,
            percentage: 0,
            updown: null,
            target: obj.baseline,
            baseline: obj.baseline,
          };
        }
      });

      let data = {
        a3id: props.a3ID,
        tab: "2",
        comments: {
          commentName: "initial State Comments",
          comments: Comments,
        },
        whiteBoard: initialStateWB,
        targetDataGrid: newTableData,
        section: props.activeTab,
        tierId: props.TierId,
        siteId: props.SiteId,
      };
      actions.manageTargetStateData(dispatch, data, props.a3ID, "2");

      notify("Initial State got saved successfully!", "success", 500);
      //save attachments
      if (selectedFiles?.length > 0) {
        let formData = new FormData();

        if (
          selectedFiles &&
          selectedFiles.length &&
          Array.isArray(selectedFiles)
        ) {
          selectedFiles.forEach((file) => {
            formData.append("files", file);
          });
        }
        formData.append("A3Id", props.a3ID);
        formData.append("TierID", props.TierId);
        formData.append("attachmentType", "KPIInitialState");
        formData.append("activeTab", props.activeTab);

        AsyncCallHandler(
          NEXUS_CONST.MANAGE_ATTACHMENT_A3,
          NEXUS_CONST.PUT,
          formData
        ).then((res) => {
          // setEanbleSave(false);
          // dispatch({ type: ACTION_TYPES.RCA_ATTACHMENT, payload: res.data });
          actions.GetAttachmentsDataA3(dispatch, props.a3ID, "KPIInitialState");
          setSelectedFiles([]);
        });
      }
      props.handleA3Save();
      props.setisOpen("2");
    }
  };

  return (
    <>
      <div>
        {" "}
        <h2 className="sps_title">Initial State</h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveInitialstate}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="434px" className="sps-box-s">
        <div style={{ width: "50%", display: "inline-block" }}>
          {GridData && (
            <DataGrid
              style={{ paddingTop: "10px", paddingRight: "20px" }}
              ref={dataGridRef}
              dataSource={GridData}
              allowColumnReordering={true}
              showBorders={true}
              onExporting={() =>
                postUserLog({
                  event: `Box 2 -Initial State Export`,
                  data: {
                    action: `Initial State exported for A3-${props.a3ID}`,
                    module: "Digital Tier",
                    section: props.activeTab,
                    siteUId: props.SiteId,
                    widget: "Strategic A3",
                    tierId: props.TierId,
                  },
                })
              }
              {...initialstateConfig}
              {...handlers}
              wordWrapEnabled={true}
              onOptionChanged={handleGridOptionChanged}
              width={"100%"}
            >
              <Paging enabled={false} />
              <SearchPanel
                visible={true}
                onTextChange={(e) => {
                  if (!isEmpty(e)) {
                    postUserLog({
                      event: "Box 2 - Initial State Grid Search",
                      data: {
                        action: `${e} searched in initial state grid A3-${props.a3ID}`,
                        module: "Digital Tier",
                        section: props.activeTab,
                        siteUId: props.SiteId,
                        widget: "Strategic A3",
                        tierId: props.TierId,
                      },
                    });
                  }
                }}
              />
              <Column
                dataField="type"
                caption="Type"
                allowFiltering={false}
                width={100}
              >
                <Lookup dataSource={typeValue} />
                <RequiredRule />
              </Column>
              <Column
                dataField="kpi"
                caption="Key Performance Indicator"
                allowFiltering={false}
                cssClass="WrappedColumn"
                width={300}
                minWidth={20}
              >
                <RequiredRule />
              </Column>
              <Column
                dataField="baseline"
                caption="Baseline"
                allowFiltering={false}
                cssClass="WrappedColumn"
                width={100}
                minWidth={20}
                dataType={"number"}
              >
                <RequiredRule />
              </Column>
              <Column
                dataField="id"
                caption="id"
                visible={false}
                minWidth={20}
              ></Column>
              <Column
                dataField="percentage"
                caption="percentage"
                visible={false}
                minWidth={20}
              ></Column>
              <Column
                dataField="updown"
                caption="updown"
                visible={false}
                minWidth={20}
              ></Column>
              <Column
                dataField="target"
                caption="target"
                visible={false}
                minWidth={20}
              ></Column>
              <Column
                dataField="typeId"
                caption="typeId"
                visible={false}
                minWidth={20}
              ></Column>
            </DataGrid>
          )}
        </div>
        <div
          style={{
            width: "45%",
            display: "inline-block",
            position: "relative",
            top: "-37px",
          }}
        >
          {" "}
          <TextArea
            label="Qualitative Comments *"
            labelMode="floating"
            value={Comments}
            onValueChanged={handlTextBox}
            wordWrapEnabled={true}
            className="dx-field-text"
            maxLength={500}
          ></TextArea>
          <span style={{ display: "table", marginTop: "10px" }}>
            <h2>Expected Supporting Documents : </h2>
            <h4>- SIPOC</h4> <h4>- VSM</h4>
          </span>
        </div>
        <div>
          {config.DEV_DISPLAY_OPTIONS && (
            <div className="wb-act-blk no-print">
              <Button
                className="rps-wb-btn"
                type="normal"
                onClick={() => {
                  setWBRc(!WBRc);
                  postUserLog({
                    event: "Box 2 - Initial State",
                    data: {
                      action: `Whiteboard selected for A3-${props.a3ID}`,
                      module: "Digital Tier",
                      section: props.activeTab,
                      siteUId: props.SiteId,
                      widget: "Strategic A3",
                      tierId: props.TierId,
                    },
                  });
                }}
              >
                <span className="icon whiteboard wh-50"></span>
              </Button>
            </div>
          )}
          {config.DEV_DISPLAY_OPTIONS && WBRc && (
            <>
              <WhiteBoard
                siteId={props.SiteId}
                isRps={true}
                wbRef={wBIs}
                rpsData={utils.get("wbData_isa3")}
                widgetId={"isa3"}
              />
            </>
          )}
          <div style={{ display: "flex" }}>
            <div style={{ width: "43%" }} className="no-print">
              <div className="dx-field no-print">
                <div className="dx-field-label">Initial State Attachment</div>

                <FileUploader
                  className="dx-field-value gridavailable"
                  selectButtonText="Choose file"
                  labelText="Max. File Size 4 MB"
                  accept="*"
                  uploadMode="uploadUrl"
                  multiple={true}
                  onValueChanged={onFileSelect}
                  value={selectedFiles}
                  allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
                />
              </div>
              {attachmentsA3 &&
                attachmentsA3.map((item) => (
                  <div>
                    <a
                      style={{ cursor: "pointer" }}
                      className="clickable-hover"
                      onClick={() =>
                        onDownloadFile(
                          item?.attachmentName,
                          "StratagicA3",
                          "KPIInitialState"
                        )
                      }
                    >
                      {" "}
                      {item?.attachmentName}{" "}
                    </a>
                    <span className="rca_download">
                      <i
                        title="Download"
                        className="fa fa-download pointer"
                        // onClick={() =>
                        //   onDownloadFile(
                        //     item?.attachmentName,
                        //     "RPS",
                        //     "Breakdown"
                        //   )
                        // }
                      ></i>
                    </span>
                    <span
                      className="rca_delete"
                      style={{ padding: "0px 15px 0px 10px" }}
                    >
                      <i
                        title="Delete"
                        className="fas fa-trash pointer"
                        onClick={() => deleteFile(item.id, item.attachmentName)}
                      ></i>
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </ScrollView>
    </>
  );
};
export default InitialState;
